export const RegSource = {
  CPA: 'CPA',
  IB: 'IB',
};
